import { render, staticRenderFns } from "./WardRound.vue?vue&type=template&id=66d1b57e&"
import script from "./WardRound.vue?vue&type=script&lang=js&"
export * from "./WardRound.vue?vue&type=script&lang=js&"
import style0 from "./WardRound.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports